export default __webpack_public_path__ + "static/media/2021OsteoFemme-Foto15-Visceral-Colonliegend.779f7760.jpg";